<div class="container single-view" id="import-data">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/imports" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'IMPORTS.BTN_BACK_TO_IMPORT' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="upload-data-title" class="section-title">{{ 'IMPORT_CREATE.TITLE' | translate }}</h1>
          <p data-testid="upload-data-subtitle" class="section-subtitle mt-1 text-base">{{ 'IMPORT_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="importDataForm">
              <div class="row">
                <div class="flex flex-col col-12 mb-3">
                  <label data-testid="upload-data-select-data-label" class="block text-sm" for="dataType">{{ 'IMPORT_CREATE.SELECT_DATA_TO_IMPORT' | translate
                    }}:</label>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                  <app-custom-dropdown
                    data-testid="upload-data-select-data"
                    [placeholder]="'IMPORT_CREATE.PLACEHOLDER_SELECT_DATA_TYPE' | translate"
                    [options]="dataTypesList"
                    optionLabel="name"
                    optionValue="value"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [showSearchbox]="true"
                    [searchMode]="'local'"
                    [pageSize]="10"
                    formControlName="dataType">
                  </app-custom-dropdown>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4" [ngClass]="{'disabled': !(importDataForm.get('dataType')?.value?.length) }">
                  <button data-testid="download-template-btn" class="btn outline-btn" [disabled]="!(importDataForm.get('dataType')?.value?.length)" (click)="downloadTemplateCSV()">{{ 'IMPORT_CREATE.BTN_DOWNLOAD_CSV_TEMPLATE' | translate }}</button>
                </div>
              </div>
              <div class="flex flex-col col-12">
                <p-fileUpload data-testid="upload-data-file-upload"
                  name="file" accept=".csv" maxFileSize="1000000"
                  chooseLabel="{{ 'IMPORT_CREATE.BTN_ATTACH_FILE' | translate }}"
                  (onSelect)="onFileUpload($event)"
                  (onRemove)="onFileRemove($event)"
                  [auto]="true"
                  [customUpload]="true"
                  [uploadHandler]="onFileUpload"
                  [showUploadButton]="false"
                  [showCancelButton]="false">
                  <ng-template pTemplate="empty">
                    <div class="flex align-items-center justify-content-center flex-column">
                      <i class="pi pi-cloud-upload border-2"></i>
                      <p data-testid="upload-data-drag-and-drop-label" class="mt-2 mb-1">{{ 'IMPORT_CREATE.ATTACH_FILES_BY_DRAG_AND_DROP' | translate }}</p>
                    </div>
                  </ng-template>
                </p-fileUpload>
                <p class="mt-2"><span class="text-sm font-medium">{{ 'IMPORT_CREATE.MAXIMUM_UPLOAD_FILE_SIZE' | translate }}</span></p>
                <div class="error-hint-wr">
                  @if (fileUploadError) {
                    <small data-testid="upload-error" class="p-error">
                      {{ fileUploadError }}
                    </small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="container single-view">
                  <div class="col-12 mt-3 mb-2 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="upload-data-import-btn" class="btn primary-btn" [disabled]="!isSubmitEnabled()" (click)="uploadFile()">{{
                        'IMPORT_CREATE.BTN_ADD_NEW_IMPORT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
